import {useUserStore} from '@common/stores';
import {defineNuxtPlugin} from 'nuxt/app';
import {useLocale} from '#imports';

export default defineNuxtPlugin(async () => {
    const {locale} = useLocale();

    const userStore = useUserStore();
    userStore.userLocale = locale.value;
});
